import type {
  ImpactHapticFeedbackStyle,
  NotificationHapticFeedbackType,
} from '@telegram-apps/sdk-react'
import { hapticFeedback as hapticFeedbackSdk } from '@telegram-apps/sdk-react'

export const useHapticFeedback = () => {
  const hapticFeedback = (
    options:
      | {
          impact: ImpactHapticFeedbackStyle
        }
      | {
          notification: NotificationHapticFeedbackType
        }
      | {
          selection: true
        },
  ): boolean => {
    if (hapticFeedbackSdk.isSupported()) {
      if ('impact' in options) {
        hapticFeedbackSdk.impactOccurred(options.impact)
        return true
      }
      if ('notification' in options) {
        hapticFeedbackSdk.notificationOccurred(options.notification)
        return true
      }
      if ('selection' in options) {
        hapticFeedbackSdk.selectionChanged()
        return true
      }
      options satisfies never
      return false
    }
    console.log('Haptic feedback not supported', options)
    return false
  }

  return {
    hapticFeedback,
  }
}
